{
  "aiGeneratedAnswer": "एआई द्वारा जनरेट किया गया उत्तर",
  "allCategories": "सभी श्रेणियाँ",
  "appliedFiltersToCurrentSearch": "वर्तमान खोज पर लागू फ़िल्टर",
  "apply": "लागू करें",
  "applyFilters": "फ़िल्टर लागू करें",
  "autocompleteOptionsFound_one": "{{count}}{{label}} स्वतः पूर्ति विकल्प मिला।",
  "autocompleteOptionsFound_other": "{{count}}{{label}} स्वतः पूर्ति विकल्प मिले।",
  "autocompleteSuggestion": "स्वतः पूर्ति सुझाव: {{suggestion}}",
  "autocompleteSuggestionsFound_one": "{{count}} स्वतः पूर्ति सुझाव मिला।",
  "autocompleteSuggestionsFound_other": "{{count}} स्वतः पूर्ति सुझाव मिले।",
  "basedOnYourDevice": " (आपके डिवाइस के आधार पर)",
  "basedOnYourInternetAddress": " (आपके इंटरनेट पते के आधार पर)",
  "categoriesText_one": "निम्नलिखित श्रेणी में परिणाम मिले - <strong>{{query}}</strong>",
  "categoriesText_other": "निम्नलिखित श्रेणियों में परिणाम मिले - <strong>{{query}}</strong>",
  "clearAll": "सभी साफ़ करें",
  "clearMinAndMax": "न्यूनतम और अधिकतम साफ़ करें",
  "clearTheRangeToSelectOptions": "विकल्प चुनने के लिए सीमा साफ़ करें।",
  "clearTheSearchBar": "खोज बार साफ़ करें",
  "conductASearch": "खोज करें",
  "currentLocation": "वर्तमान स्थान",
  "didYouMean": "क्या आपका मतलब <button>{{correctedQuery}}</button> था",
  "dropDownScreenReaderInstructions": "जब स्वतः पूर्ण परिणाम उपलब्ध हों, तो समीक्षा के लिए ऊपर और नीचे के तीर कुंजी का उपयोग करें और चयन के लिए एंटर दबाएं।",
  "feedback": "प्रतिक्रिया",
  "filterGroupSearchInputLabel": "{{title}} विकल्प खोजें",
  "invalidRange": "अमान्य सीमा",
  "max": "अधिकतम",
  "min": "न्यूनतम",
  "navigateToTheNextResultsPage": "अगले परिणाम पृष्ठ पर जाएं",
  "navigateToThePreviousResultsPage": "पिछले परिणाम पृष्ठ पर जाएं",
  "noAutocompleteOptionsFound": "कोई स्वतः पूर्ति विकल्प नहीं मिला।",
  "noAutocompleteSuggestionsFound": "कोई स्वतः पूर्ति सुझाव नहीं मिला।",
  "noResultsFoundIn": "{{currentVerticalLabel}} में कोई परिणाम नहीं मिला।",
  "paginationPage": "पृष्ठ {{pageNumber}}",
  "pagination": "पृष्ठांकन",
  "readMoreAbout": "<a>{{name}}</a> के बारे में और पढ़ें",
  "recentSearch": "हाल की खोज: {{query}}",
  "recentSearchesFound_one": "{{count}} हाल की खोज मिली।",
  "recentSearchesFound_other": "{{count}} हाल की खोज मिलीं।",
  "removeFilter": "“{{displayName}}“ फ़िल्टर हटाएं",
  "resultPreview": "परिणाम पूर्वावलोकन: {{value}}",
  "resultPreviewsFound_one": "{{count}} परिणाम पूर्वावलोकन मिला।",
  "resultPreviewsFound_other": "{{count}} परिणाम पूर्वावलोकन मिले।",
  "resultsCountText_one": "{{count}} परिणाम",
  "resultsCountText_other": "{{count}} परिणाम",
  "resultsCountWithPaginationText": "{{paginateStart}} - {{paginateEnd}} में से कुल {{resultsCount}} परिणाम",
  "searchHere": "यहाँ खोजें…",
  "showingAllInstead": "इसके बजाय सभी {{currentVerticalLabel}} दिखा रहे हैं।",
  "showLess": "कम दिखाएँ",
  "showMore": "और दिखाएँ",
  "sources_one": "स्रोत",
  "sources_other": "स्रोत ({{count}})",
  "submitSearch": "खोज जमा करें",
  "suggestionResultsCount_one": "{{label}} - {{count}} परिणाम",
  "suggestionResultsCount_other": "{{label}} - {{count}} परिणाम",
  "thankYouForYourFeedback": "आपकी प्रतिक्रिया के लिए धन्यवाद!",
  "thisAnsweredMyQuestion": "इससे मेरे प्रश्न का उत्तर मिला",
  "thisDidNotAnswerMyQuestion": "इससे मेरे प्रश्न का उत्तर नहीं मिला",
  "unselectAnOptionToEnterInARange": "सीमा दर्ज करने के लिए विकल्प अनचेक करें।",
  "updateYourLocation": "अपना स्थान अपडेट करें",
  "useCurrentLocation": "वर्तमान स्थान का उपयोग करें",
  "useMyLocation": "मेरा स्थान उपयोग करें",
  "viewAll": "सभी देखें",
  "viewDetails": "विवरण देखें"
}
